import {createRouter, createWebHistory} from 'vue-router'
import InterviewView from '@/views/Interview.vue'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/:interview_id",
			name: "interview",
			component: InterviewView,
		},
	],
})

export default router;
